/**
 * @description UI库组件主入口
 */
import '@kuaizhan/kedit-font';
import KZUIComponent from './lib/base';
import { Row, Col } from './lib/Grid';
import Button from './lib/Button';
import Input from './lib/Input';
import TextArea from './lib/TextArea';
import Popover from './lib/Popover';
import Select from './lib/Select';
import Icon from './lib/Icon';
import NumberInput from './lib/NumberInput';
import Pager from './lib/Pager';
import RadioGroup, { Radio } from './lib/RadioGroup';
import Switch from './lib/Switch';
import Overlay from './lib/Overlay';
import Dialog from './lib/Dialog';
import Alert from './lib/Alert';
import Steps from './lib/Steps';
import DatePicker from './lib/DatePicker';
import DateRangePicker from './lib/DateRangePicker';
import ColorPicker from './lib/ColorPicker';
import Tip from './lib/Tip';
import Search from './lib/Search';
import Checkbox from './lib/Checkbox';
import Table from './lib/Table';
import Tabs from './lib/Tabs';
import FileSelect from './lib/FileSelect';
import Tag from './lib/Tag';
import TagSelector from './lib/TagSelector';
import TagDynamic from './lib/TagDynamic';
import Confirm from './lib/Confirm'; // import PopDialog from './lib/pop-dialog';

import Popconfirm from './lib/Popconfirm'; // import PopTip from './lib/pop-tip';

import Tooltip from './lib/tooltip';
import Modal from './lib/Modal';
import TimePicker from './lib/TimePicker';
import EventBlackHole from './lib/EventBlackHole';
import SearchSelect from './lib/SearchSelect';
import RichTextEditor from './lib/RichtextEditor';
import Switcher from './lib/Switcher';
import ImageCropper from './lib/ImageCropper';
import toptip from './lib/TopTip';
import Spin from './lib/Spin';
import Portal from './lib/Portal';
import prompt from './lib/prompt';
import StepBar from './lib/StepBar'; // import './style/''.less';

var TextInput = Input;
export { Tabs, KZUIComponent, Row, Col, Button, Input, TextInput, TextArea, Popover, Select, Icon, NumberInput, Pager, Radio, RadioGroup, Switch, Overlay, Dialog, Alert, Confirm, Steps, DatePicker, DateRangePicker, Tip, Search, Checkbox, Table, FileSelect, Tag, TagSelector, ColorPicker, Popconfirm, Tooltip, TagDynamic, Modal, TimePicker, EventBlackHole, SearchSelect, RichTextEditor, Switcher, ImageCropper, toptip, Spin, Portal, prompt, StepBar };